/**
 * Route for `outbrain-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { OutbrainIntegrationPage } from "../features/outbrain-integration/OutbrainIntegrationPage";

export const outbrainIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/outbrain-integration",
	component: OutbrainIntegrationPage,
});

export default outbrainIntegrationRoute;
